import { render, staticRenderFns } from "./release-exhibitor.vue?vue&type=template&id=2cad4ea1&scoped=true&"
import script from "./release-exhibitor.vue?vue&type=script&lang=js&"
export * from "./release-exhibitor.vue?vue&type=script&lang=js&"
import style0 from "./release-exhibitor.vue?vue&type=style&index=0&id=2cad4ea1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad4ea1",
  null
  
)

export default component.exports